<template>
  <div class="ScholarshipApplyTips">
    <!-- 首頁圖 -->
    <div class="banner">
      <h1>{{ $t("scholarshipapplytips.title") }}</h1>
    </div>
    <!-- 申請規則 -->
    <ul style="margin-bottom: 10vw" class="content-container">
      <!-- 標題 -->
      <div class="title">
        <span>{{ $t("scholarshipapplytips.title") }}</span>
      </div>
      <!-- <span>{{ $t("scholarship.test_span") }}</span> -->
      <div class="other-tips-container">
        <p v-for="item in applyData.other_tips" :key="item" v-html="item"></p>
      </div>
      <br />
      <CoButton
        :href="
          $i18n.locale == 'zh_hk'
            ? 'https://form.jotform.me/200901208739048'
            : 'https://form.jotform.me/201422358161446'
        "
        class="apply-btn"
      >
        {{ applyData.other_btn }}
      </CoButton>
      <ul v-show="fasle" class="apply-rules">
        <li v-for="(item, index) in applyTipData" :key="index">
          <i class="list-mark"></i>
          <p v-html="item"></p>
          <div v-show="index === 3" class="other-tips">
            <i class="circle"></i>
            <span>{{ $t("scholarshipapplytips.sxTip") }}</span>
          </div>
        </li>
      </ul>
      <CoButton
        v-show="fasle"
        :href="
          $i18n.locale == 'zh_hk'
            ? 'https://form.jotform.me/200901208739048'
            : 'https://form.jotform.me/201422358161446'
        "
        arrow
        class="apply-btn"
        >{{ $t("scholarshipapplytips.title") }}</CoButton
      >
    </ul>
  </div>
</template>

<script>
import CoButton from "../components/co-button/co-button.vue";
export default {
  name: "ScholarshipApplyTips",
  data() {
    return {};
  },
  components: { CoButton },
  computed: {
    applyTipData: function () {
      return this.$t("scholarshipapplytips.other_tips");
    },
    applyData: function () {
      return this.$t("scholarship");
    },
  },
};
</script>

<style scoped lang="scss">
.ScholarshipApplyTips {
  .banner {
    background-image: url("../assets/img/apply/submit now.jpg");
  }
  .content-container {
    .apply-rules {
      padding-left: 1.9vw;
      font-weight: 600;
      & > li {
        // line-height: 38px;
        position: relative;
        margin-bottom: 4.4vw;
        .other-tips {
          font-size: 12px;
          padding-left: 1vw;
          position: relative;
          font-weight: 500;
          width: 75%;
          .circle {
            display: inline-block;
            width: 0.4vw;
            height: 0.4vw;
            border-radius: 50%;
            background: #22a0d6;
            position: absolute;
            left: -0px;
            top: 8px;
          }
        }
        .list-mark {
          left: -1.9vw;
          top: 4px;
        }
      }
    }
    .apply-btn {
      width: 12vw;
      background: #229fd8;
      margin: 0 auto 5.2vw;
      font-size: 16px;
      display: block;
    }
    .other-tips-container {
      margin-top: 80px;
    }
    .apply-btn {
      display: block;
      width: 15%;
      margin: 20px auto;
    }
  }
}
@media (max-width: 768px) {
  .ScholarshipApplyTips {
    .banner {
      height: 40vw;
      display: flex;
      flex-direction: column;
      align-items: center;
      background-image: url("../assets/img/apply/submit now.jpg");
      background-size: cover;
      background-repeat: no-repeat;
      color: white;
      h1 {
        line-height: 14vw;
        font-size: 7vw;
      }
    }
    .content-container {
      width: 79vw;
      margin: 0 auto;
      .title {
        color: #85c456;
        margin: 3.4vw auto 2.8vw;
        font-size: 3vw;
        & > span {
          border-bottom: solid 0.5vw #22a0d6;
          padding-bottom: 1vw;
        }
      }
      .apply-rules {
        padding-left: 1.9vw;
        font-size: 1.5vw;
        font-weight: 600;
        & > li {
          // line-height: 38px;
          position: relative;
          margin-bottom: 4.4vw;
          .other-tips {
            font-size: 1.1vw;
            font-weight: normal;
            width: 57.5vw;
            padding-left: 1vw;
            position: relative;
            .circle {
              display: inline-block;
              width: 0.4vw;
              height: 0.4vw;
              border-radius: 50%;
              background: #22a0d6;
              position: absolute;
              left: -0px;
              top: 12px;
            }
          }
          .list-mark {
            left: -1.9vw;
            top: 4px;
          }
        }
      }
      .apply-btn {
        width: 30%;
        line-height: 7.3vw;
        background: #229fd8;
        cursor: pointer;
        margin: 0 auto 5.2vw;
        text-align: center;
        color: white;
        font-weight: bold;
        font-size: 1.9vw;
      }
    }
  }
}
</style>
